import { ICompileService, IPromise, IQService, Injectable } from "angular";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { RecordDataSource } from "../../../records/grids";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { StateService } from "@uirouter/angularjs";

import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";

export const vsObjectName = "machine";

export function machineConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    "$q",
    ServerUtilityName,
    GridSettingsServiceName,
    "$state",
    ColumnDefinitionServiceName,
    "$compile",
    (
      $q: IQService,
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
      $state: StateService
    ) =>
      new MachineGridConfiguration(
        $q,
        serverUtility,
        gridSettingsService,
        $state
      ),
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionServiceName,
    "$compile",
    (
      columnDefinitionService: ColumnDefinitionService,
      $compile: ICompileService
    ) => [
      columnDefinitionService.getNumberColDef({
        field: "Id",
        filter: new FilterProvider("Id", $compile)
          .defaultNumberFilters()
          .getGridFilterFactory(),
        hide: true,
      }),
      ...machineConfigurationColumns(columnDefinitionService, $compile),
    ],
  ]);
}
machineConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionServiceProviderName,
];

export function machineConfigurationColumns(
  columnDefinitionService: ColumnDefinitionService,
  $compile: ICompileService
): ColDef[] {
  return [
    columnDefinitionService.getDateColDef({
      field: "Date",
      header: "Change Date",
    }),
    columnDefinitionService.getStringColDef({
      field: "SerialNumber",
    }),
    columnDefinitionService.getStringColDef({
      field: "SlotNumber",
    }),
    columnDefinitionService.getStringColDef({
      field: "Status",
      filter: new FilterProvider("Status", $compile)
        .addFilter(
          "=",
          new OptionsFilter({
            displayName: "=",
            queryFieldNames: ["Status"],
            options: [
              {
                display: "Floor",
                value: "Floor",
              },
              {
                display: "Warehoused",
                value: "Warehoused",
              },
              {
                display: "Decommissioned",
                value: "Decommissioned",
              },
            ],
          })
        )
        .getGridFilterFactory(),
    }),
    columnDefinitionService.getStringColDef({
      field: "ManufacturerName",
      header: "Manufacturer",
    }),
    columnDefinitionService.getStringColDef({
      field: "CabinetTypeName",
      header: "Cabinet",
    }),

    columnDefinitionService.getStringColDef({
      field: "Section",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "Bank",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "Slot",
      header: "Position",
      hide: true,
    }),

    columnDefinitionService.getStringColDef({
      field: "ConversionTypeName",
      header: "Conversion Type",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "Progressive",
      header: "Progressive?",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "GameName",
      header: "Game Name",
    }),
    columnDefinitionService.getBooleanColDef({
      field: "MachineConfigurationLeased",
      header: "Configuration Leased",
    }),
    columnDefinitionService.getStringColDef({
      field: "FeeStructureTypeId",
      header: "Fee Structure Type Id",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "DisplayTypeName",
      header: "Display Type Name",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "ModelNumberName",
      header: "Model Number Name",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "NumberOfReels",
      header: "Number Of Reels",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "MachineConfigurationChangeActionId",
      header: "Configuration Change Action Id",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "AveragePar",
      header: "Average Par",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "AverageParWithProgressiveIncrementPercentage",
      header: "Average Par with Prog Inc%",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "Order",
      header: "Order",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "JackpotLimit",
      header: "Jackpot Limit",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "MachineAreaName",
      header: "Machine Area Name",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "MachineBankConfigId",
      header: "Machine Bank Config Id",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "MachineBankConfigName",
      header: "Machine Bank Config Name",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "CameraCoverage",
      header: "Camera Coverage",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "FreePlayEnabled",
      header: "Free Play Enabled",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "FourPercent",
      header: "4%",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "AdjustedByCompliance",
      header: "Adjusted By Compliance",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "ProgressiveController",
      header: "Progressive Controller",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "Leased",
      header: "Leased",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "LeasedSoftware",
      header: "Leased Software",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "SpecialPUPD",
      header: "Special PUPD",
      hide: true,
    }),
    columnDefinitionService.getNumberColDef({
      field: "CreditLimit",
      header: "Credit Limit",
      hide: true,
    }),
    columnDefinitionService.getNumberColDef({
      field: "BillLimit",
      header: "Bill Limit",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "Poker",
      header: "Poker",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "FirstToFloor",
      header: "First To Floor",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "FirstToTucson",
      header: "First To Tucson",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "FirstToArizona",
      header: "First To Arizona",
      hide: true,
    }),
    columnDefinitionService.getBooleanColDef({
      field: "CurrentConfiguration",
      header: "Current Configuration",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "PropertyName",
      header: "Property",
      hide: true,
    }),
    columnDefinitionService.getStringColDef({
      field: "Notes",
      header: "Notes",
      hide: true,
    }),
  ];
}

class MachineGridConfiguration implements GridConfiguration {
  columns?: ColDef[];
  columnDefinitionSet?: string = vsObjectName;
  onItemCommand?: Injectable<(...args: any[]) => IPromise<void>> = [
    () => {
      return this.$q.when();
    },
  ];
  gridDataSource?: RecordDataSource = new RecordDataSource(
    this.serverUtility,
    "/api/machines/machine"
  );
  defaultSort?: string = "Status,SerialNumber";
  nameSingular?: string = "Machine Configuration";
  namePlural?: string = "Machine Configurations";
  showAddButton?: boolean = true;
  showAddButtonPermission?: string = "machineEdit";
  gridSelectionChanged?: Injectable<(...args: any[]) => void> = [
    () => {
      return this.$q.when();
    },
  ];
  showSelectButtons?: boolean = true;
  gridSettings?: IGridSettings;

  static $inject = ["$q", ServerUtilityName, GridSettingsServiceName, "$state"];
  constructor(
    private readonly $q: IQService,
    private readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly $state: StateService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("main.machines.grid")
    );
  }

  onAddNew = () => {
    return this.$state.go("^.add").then(() => {});
  };
}
